module.exports = __webpack_public_path__ + "media/images/train-ef6089e6d4508624229f70afbb2b5f1a.svg";